// @flow

import topic from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Topic';

import developerPlatform from '../loggedOut/developerPlatform';
import solutionPartner from '../loggedOut/solutionPartner';

export const content = {
  zendeskCustomFieldId: 38147919558029,
  label: 'What would you like more information about?',
  items: [
    {
      value: 'developer-platform',
      icon: 'miscBolt',
      label: 'Zapier Developer Platform & Integration Partner Program',
      zendeskCustomFieldValue: 'pcf-developer-platform',
      child: developerPlatform,
    },
    {
      value: 'solution-partner',
      icon: 'personCircleFill',
      label: 'Zapier Solution Partner Program',
      zendeskCustomFieldValue: 'pcf-solution-partner',
      child: solutionPartner,
    },
  ],
};

const Topic = topic(content);

export default Topic;
